// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__WLPpV","content":"styles_content__2cGxY","selectAll":"styles_selectAll__SdruX"};